import { ReactComponent as InfoIcon } from '@blink/assets/src/icons/infoCircleFillCurrent.svg';
import React, { ReactElement } from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './Tooltip';

export enum TooltipPosition {
    Top = 'top',
    Bottom = 'bottom',
    Left = 'left',
    Right = 'right',
}

type TooltipWrapperProps = {
    text?: string;
    side?: TooltipPosition;
    icon?: ReactElement;
    className?: string;
};

const TooltipWrapper = ({
    text,
    side = TooltipPosition.Bottom,
    icon,
    className = '',
}: TooltipWrapperProps) => {
    if (!text) return null;

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    {icon ? icon : <InfoIcon className={`w-5 h-5 ${className}`} />}
                </TooltipTrigger>
                <TooltipContent side={side} sideOffset={38}>
                    {text}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

TooltipWrapper.positions = TooltipPosition;

export { TooltipWrapper };
